import { render, staticRenderFns } from "./imodalEditNote.vue?vue&type=template&id=5c731550&"
import script from "./imodalEditNote.vue?vue&type=script&lang=js&"
export * from "./imodalEditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports